module.exports = __webpack_public_path__ + "static/media/video-placeholder.ea999dca.png";